export function isRCTokenValue (value: string): boolean {
  return value === 'r' || value === 'R' || value === 'c' || value === 'C';
}
